import { useAppDispatch } from '@/Application/Hooks/Redux';
import { useGtmBillingProduct } from '@/modules/perseo-billing/hooks';
import { setIsGiftCardModalFindItOpen } from '@/modules/perseo-billing/store/slices/billing';
import { Link } from '@/modules/perseo-billing/ui/react/src';

export const WhereToFindLink = () => {
  const dispatch = useAppDispatch();
  const { linkGiftCardFindItGtm } = useGtmBillingProduct();

  return (
    <Link
      className="co-ml-auto"
      onClick={() => {
        dispatch(setIsGiftCardModalFindItOpen(true));
        linkGiftCardFindItGtm();
      }}
    >
      ¿Dónde lo encuentro?
    </Link>
  );
};
